import axios from 'axios';

export type GetRequestData = {
  url: string;
  responseType: any;
  headers?: any;
  data?: any;
};

export const getRequest = async (
  getRequestData: GetRequestData,
): Promise<any> => {
  const { url, data, responseType, headers } = getRequestData;

  const response = await axios({
    url,
    headers: {
      ...headers,
      'current-role': localStorage.getItem('currentRole') ?? '',
      authorization: localStorage.getItem('tokens') ?? '',
    },
    method: 'GET',
    responseType,
    data,
  });

  return response;
};
